import { TrafikenConfig } from '../TrafikenConfig';
import { AjaxSource } from './AjaxSource';
import type { AjaxSourceOptions } from './Sources.types';

const defaultOptions = (municipality) => ({
    id: `winter-bike-roads-${municipality}`,
    url: `${TrafikenConfig.infoLayerServiceBaseUrl}/map-layers/winter-bike-sth/${municipality}.json`,
    displayName: 'Vintercykelvägar',
});

export class WinterBikeRoadsSthSource extends AjaxSource {
    constructor(municipality: string, options?: AjaxSourceOptions) {
        super({ ...defaultOptions(municipality), ...options });
    }
}
